import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronBaseIcon from '@assets/img/icons/chevron.svg?react';

import { useCountDownTimer } from '@/common/hooks/count-down-timer';
import { timeStringFormat } from '@/common/lib/timer';
import { Picture } from '@/components/ui/Picture/Picture';
import { SecondaryTimer } from '@/components/ui/Timer/SecondaryTimer';
import { useModal } from '@/context/ModalContext';
import { getPaidRewardPlanCost } from '@/redux/selectors/earnRewardsSelector';
import { useAppSelector } from '@/redux/store';

import bonusPng from '/img/icons/reward/bonus.png';
import bonusWebp from '/img/icons/reward/bonus.webp';
import mapPng from '/img/icons/reward/map.png';
import mapWebp from '/img/icons/reward/map.webp';

export const DailyRewardBanner: FC = () => {
  const nextClaimTime = useAppSelector(
    (state) => state.earnRewards.rewards?.nextClaimTime,
  );
  const cost = useAppSelector(getPaidRewardPlanCost);
  const seconds = useCountDownTimer(nextClaimTime || 0);
  const { setEarnRewardModal } = useModal();

  const { t } = useTranslation();

  return (
    <div className="earn_reward mb-2" onClick={() => setEarnRewardModal(true)}>
      {!seconds && <div className="active-green-gradient"></div>}
      <div className="earn_reward_info">
        <Picture
          className="size-12"
          img={cost ? mapPng : bonusPng}
          webp={cost ? mapWebp : bonusWebp}
          alt="bonus"
        />
        {/* <picture>
                  <source srcSet={bonusWebp} type="image/webp" />
                  <img src={bonusPng} alt="bonus" width={40} />
                </picture> */}
        <div>
          <span>{!cost ? t('Reward Track') : t('Epic Reward Track')}</span>
          {!seconds ? (
            <p style={{ color: 'var(--main-primary, #82E024)' }}>
              {t('Get your reward')}
            </p>
          ) : (
            <p style={{ color: 'var(--text-gray-dark, #FFFFFF99)' }}>
              {t('Next reward')}:
              <SecondaryTimer
                className="reward_timer"
                value={timeStringFormat(seconds * 1000)}
                variant="boost"
              />
            </p>
          )}
        </div>
      </div>
      {!seconds && <div className="active-green-point top-1 right-1"></div>}
      <ChevronBaseIcon className="text-white/40 w-6 h-6" />
    </div>
  );
};
